import { render, staticRenderFns } from "./EditExtra.vue?vue&type=template&id=280fd86a&"
import script from "./EditExtra.vue?vue&type=script&lang=js&"
export * from "./EditExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports